import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-900 flex flex-col justify-center py-12 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "mt-6 sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_3 = { class: "bg-gray-800 py-8 px-6 shadow-md sm:rounded-lg sm:px-10 border border-gray-700" }
const _hoisted_4 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_5 = {
  key: 1,
  class: "bg-green-900 border border-green-700 text-green-300 px-3 py-2 rounded relative text-sm"
}
const _hoisted_6 = {
  key: 2,
  class: "bg-yellow-900 border border-yellow-700 text-yellow-300 px-3 py-2 rounded relative text-sm",
  role: "alert"
}
const _hoisted_7 = {
  key: 3,
  class: "bg-green-900 border border-green-700 text-green-300 px-3 py-2 rounded relative text-sm",
  role: "alert"
}
const _hoisted_8 = {
  key: 4,
  class: "bg-red-900 border border-red-700 text-red-300 px-3 py-2 rounded relative text-sm",
  role: "alert"
}
const _hoisted_9 = { class: "block sm:inline" }
const _hoisted_10 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_FormButton = _resolveComponent("FormButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "sm:mx-auto sm:w-full sm:max-w-md" }, [
      _createElementVNode("h2", { class: "text-center text-2xl md:text-3xl font-extrabold text-white" }, " Zaboravili ste lozinku? "),
      _createElementVNode("p", { class: "mt-2 text-center text-sm text-gray-400" }, " Unesite vašu email adresu i poslaćemo vam link za reset ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleForgotPassword && _ctx.handleForgotPassword(...args)), ["prevent"])),
          class: "space-y-6"
        }, [
          _createVNode(_component_FormInput, {
            id: "email",
            name: "email",
            type: "email",
            label: "Email adresa",
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            placeholder: "Email adresa",
            required: "",
            error: _ctx.emailError,
            onBlur: _ctx.validateEmailAndCheckExists,
            onInput: _ctx.onEmailInput
          }, null, 8, ["modelValue", "error", "onBlur", "onInput"]),
          (_ctx.email && !_ctx.emailError && !_ctx.emailChecked)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bg-blue-900 border border-blue-700 text-blue-300 px-3 py-2 rounded relative text-sm" }, [
                  _createElementVNode("span", { class: "block sm:inline" }, " 📧 Molimo potvrdite da je ova email adresa ispravna pre slanja zahteva. ")
                ], -1)),
                _createVNode(_component_FormButton, {
                  type: "button",
                  onClick: _ctx.checkEmailExists,
                  loading: _ctx.isCheckingEmail,
                  disabled: _ctx.isCheckingEmail || !_ctx.email || !!_ctx.emailError,
                  class: "w-full bg-blue-600 hover:bg-blue-700"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isCheckingEmail
                  ? 'Proverava se email...'
                  : 'Proveri email adresu'), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.emailChecked && !_ctx.emailNotFound)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "block sm:inline" }, " ✅ Email adresa je potvrđena. Možete poslati zahtev za reset lozinke. ", -1)
              ])))
            : _createCommentVNode("", true),
          (_ctx.emailNotFound)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[4] || (_cache[4] = [
                _createElementVNode("span", { class: "block sm:inline" }, " Email adresa nije pronađena u našoj bazi podataka. Molimo proverite da li ste uneli ispravnu email adresu. ", -1)
              ])))
            : _createCommentVNode("", true),
          (_ctx.successMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[5] || (_cache[5] = [
                _createElementVNode("span", { class: "block sm:inline" }, [
                  _createTextVNode("Zahtev za resetovanje lozinke je uspešno poslat."),
                  _createElementVNode("br"),
                  _createTextVNode("Poslali smo Vam e-mail sa uputstvima za resetovanje lozinke.")
                ], -1)
              ])))
            : _createCommentVNode("", true),
          (_ctx.serverError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.serverError), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.emailChecked && !_ctx.emailNotFound)
            ? (_openBlock(), _createBlock(_component_FormButton, {
                key: 5,
                type: "submit",
                loading: _ctx.isLoading,
                disabled: _ctx.isLoading || !_ctx.isFormValid || _ctx.emailNotFound,
                class: "w-full"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode(" Pošaljite link za reset ")
                ])),
                _: 1
              }, 8, ["loading", "disabled"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/login",
              class: "text-indigo-400 hover:text-indigo-300 text-sm"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" Nazad na prijavu ")
              ])),
              _: 1
            })
          ])
        ], 32)
      ])
    ])
  ]))
}